export type InvoiceState =
  | "Undefined"
  | "Concept"
  | "Active"
  | "PartiallyPaid"
  | "Paid"
  | "Canceled"
  | "DirectDebitPayment"
  | "RepaymentSchedule"
  | "TransferToInvoice";

export const InvoiceState = {
  Undefined: "Undefined" as InvoiceState,
  Concept: "Concept" as InvoiceState,
  Active: "Active" as InvoiceState,
  PartiallyPaid: "PartiallyPaid" as InvoiceState,
  Paid: "Paid" as InvoiceState,
  Canceled: "Canceled" as InvoiceState,
  // Avízo (Na cestě)
  DirectDebitPayment: "DirectDebitPayment" as InvoiceState,
  // Splátkový kalendář
  RepaymentSchedule: "RepaymentSchedule" as InvoiceState,
  // Převod do následující faktury
  TransferToInvoice: "TransferToInvoice" as InvoiceState,
};
